
import { HostType } from "./abstractions";

export function detectHost(): HostType {
  const params = new URLSearchParams(window.location.search);
  const hostInQueryParam = params.get("host");

  switch (hostInQueryParam) {
    case HostType.TEAMS:
      return HostType.TEAMS;

    case HostType.E2E:
      return HostType.E2E;

    default:
      return HostType.WEB;
  }
}